var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.029,4.913V20.394a.675.675,0,0,1-.673.673h0a.675.675,0,0,1-.673-.673V6.452H4.913A1.537,1.537,0,0,0,3.375,7.99V21.837a1.537,1.537,0,0,0,1.538,1.538H21.889a1.487,1.487,0,0,0,1.486-1.486V4.913a1.537,1.537,0,0,0-1.538-1.538l-13.365.1A1.378,1.378,0,0,0,7.029,4.913ZM10.2,6.452H14.24a.675.675,0,0,1,.673.673h0a.675.675,0,0,1-.673.673H10.2a.675.675,0,0,1-.673-.673h0A.675.675,0,0,1,10.2,6.452Zm0,7.692h7.115a.675.675,0,0,1,.673.673h0a.675.675,0,0,1-.673.673H10.2a.675.675,0,0,1-.673-.673h0A.675.675,0,0,1,10.2,14.144Zm9.423,5.192H10.2a.675.675,0,0,1-.673-.673h0a.675.675,0,0,1,.673-.673h9.423a.675.675,0,0,1,.673.673h0A.675.675,0,0,1,19.625,19.337Zm0-7.692H10.2a.675.675,0,0,1-.673-.673h0A.675.675,0,0,1,10.2,10.3h9.423a.675.675,0,0,1,.673.673h0A.675.675,0,0,1,19.625,11.644Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.41120528ffb2ff97b3545428e8ddcb8b.svg";
export { ForwardRef as ReactComponent };